<template>
  <el-dialog
    v-dialogDrag
    :title="`${$t('importFromExcel')}`"
    :visible.sync="uploadExcelVisible"
    :close-on-click-modal="false"
    :before-close="closeDialog"
  >
    <el-steps :active="active" finish-status="success" simple class="mt-20px">
      <el-step v-if="isVariable" :title="`${$t('selectRule')}`"></el-step>
      <el-step v-else class="fz-14" :title="`${$t('downloadTemplete')}`"></el-step>
      <el-step :title="`${$t('uploadFile')}`"></el-step>
      <el-step :title="`${$t('complete')}`"></el-step>
    </el-steps>
    <div v-show="active === 1">
      <div class="text-center pt-30px">
        <div class="upload-demo">
          <div v-if="isVariable" class="attrRules-box pl-30px">
            <div v-for="(val, index) in attrRulesList" :key="index" class="mb-10px">
              <el-radio v-model="attrRulesVal" :label="val.id">{{ val.name }}</el-radio>
            </div>
          </div>
          <div v-else class="el-upload el-upload--text down-text">
            <div class="el-upload-dragger">
              <i
                @click="downloadTemplate"
                class="icon iconfont icon-bg-excel main-color"
                style="height: 100px; font-size: 70px"
              ></i>
              <div class="el-upload__text">
                {{ $t('clickDownloadTemplete') }}
                <em class="text-color" @click="nextStep">{{ $t('nextStep') }}</em>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="active === 2" class="text-center">
      <el-upload
        v-loading="loading"
        ref="upload"
        drag
        action="https://xx.yy.zz"
        :show-file-list="false"
        :before-upload="getFileContent"
        :http-request="uploadExcel"
        :multiple="false"
      >
        <i style="font-size: 67px" class="iconfont icon-bg-upload main-color"></i>
        <div class="el-upload__text">
          {{ $t('onlyOne') }}
          <em>{{ $t('clickUpload') }}</em>
        </div>
      </el-upload>
    </div>
    <div class="padding-1" v-show="active === 3">
      <div style="text-align: center">
        <div class="upload-demo">
          <div class="el-upload el-upload--text down-text">
            <div class="el-upload-dragger pt-20px">
              <span class="mt-30px">
                <i
                  class="iconfont icon-bg-download main-color"
                  style="font-size: 54px"
                  @click="downResultFile"
                ></i>
              </span>
              <div class="el-upload__text" v-if="resultFile">{{ $t('downloadUploadResult') }}</div>
              <div class="el-upload__text" v-else>{{ $t('uploadSuccess') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog" v-if="active !== 3" :loading="loading">
        {{ $t('cancel') }}
      </el-button>
      <el-button v-if="active === 2" type="primary" @click="active = 1" :loading="loading">
        {{ $t('previous') }}
      </el-button>
      <el-button v-if="active === 3" type="primary" @click="closeDialog" :loading="loading">
        {{ $t('complete') }}
      </el-button>
      <el-button v-if="active === 1" type="primary" @click="nextStep" :loading="loading">
        {{ $t('nextStep') }}
      </el-button>
      <el-button @click="active = 2" v-if="active === 3 && excelType === 'specStructurization'">
        {{ $t('previous') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import CommonService from '@/services/Common'
import fnMixin from '@/assets/js/fnMixins'
import CommonStdService from '@/services/CommonStd'
import EncodeRuleManage from '@/services/encodeRule'
import DocumentManagementService from '@/services/documentManagement'
import ApiMixinPoint from '@/assets/js/api/measuringPoint'
import associatedObjectsService from '@/services/associatedObjectsService'
import DataRuleSettingService from '@/services/DataRuleSettingService'
import MetadataManageService from '@/services/MetadataManageService'

export default {
  name: 'upload',
  mixins: [ApiMixinPoint],
  props: {
    excelType: {
      type: String,
    },
    attrType: {
      type: Number,
    },
    customization: {
      type: Boolean,
      default: false,
    },
    hash: {
      type: String,
      default: '',
    },
    excelParams: {
      type: Object,
      required: false,
    },
    params: {
      type: Object,
      required: false,
    },
    isVariable: {
      // 是不是特殊的功能
      type: Boolean,
      default() {
        return false
      },
    },
    stdClassName: {
      // 实体名称
      type: String,
    },
    standardId: {
      // 标准id
      type: String,
    },
  },
  data() {
    return {
      uploadExcelVisible: false,
      successCallBackData: null,
      active: 1,
      file: '',
      loading: false,
      resultFile: '',
      progressPercent: 1,
      timer: null,
      currentUploadFileId: '',
      startTimer: true,
      attrRulesList: [], // 导入属性规则列表集合
      attrRulesVal: '', // 选中的属性规则文件
      resultFileName: '', // 返回结果文件名称
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  watch: {
    uploadExcelDialog(bol) {
      console.log(bol, 'bol112233')
    },
    isVariable: {
      handler(val) {
        if (val) {
          this.EncodeRuleManage()
        }
      },
      immediate: true,
    },
  },
  created() {},
  beforeDestroy() {},
  methods: {
    // 获取属性规则列表集合
    async EncodeRuleManage() {
      const res = await EncodeRuleManage.getAttributeRuleList({
        pageNo: 1,
        pageSize: 9999,
        site_id: this.currentProject.id,
        sort: 'seq_no:asc',
      })
      if (res && res.data && res.code === 0) {
        this.attrRulesList = res.data
      }
    },
    // 下载模板
    async downloadTemplate() {
      let ADDRESS = ''
      let res
      let API = ''
      switch (this.excelType) {
        // 下载元数据采集导入模板
        case 'collection':
          res = await MetadataManageService.downloadTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('元数据采集导入模板', res)
          }
          break
        // 下载数据规则设置导入模板
        case 'dataRuleSet':
          res = await DataRuleSettingService.downloadTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('数据规则设置导入模板', res)
          }
          break
        // 下载基础规则导入模板
        case 'baseRule':
          res = await EncodeRuleManage.getBaseRuleTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('基础规则导入模板', res)
          }
          break
        // 下载编码规则导入模板
        case 'encodeRule':
          res = await EncodeRuleManage.getEncodeRuleTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('编码规则导入模板', res)
          }
          break
        // 下载数据字典导入模板
        case 'DicCate':
          res = await CommonStdService.exportDataDictionaryTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('数据字典模板', res)
          }
          break
        // 下载属性规则导入模板
        case 'attributeRule':
          res = await EncodeRuleManage.getAttributeRuleTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('属性规则导入模板', res)
          }
          break
        // 下载实体对象导入模板
        case 'objTransfer':
          res = await DocumentManagementService.getTemplate({ standardId: this.standardId })
          if (res) {
            fnMixin.methods.downLoadExcel('实体对象导入模板', res)
          }
          break
        // 下载实体文档导入模板
        case 'documentList':
          const documentListRes = await DocumentManagementService.getDocumentTemplate({
            standardId: this.params.standardId,
          })
          if (documentListRes) {
            fnMixin.methods.downLoadExcel('实体文档导入模板', documentListRes)
          }
          break
        // 下载关联关系导入模板
        case 'relation':
          res = await DocumentManagementService.getTagFileAssociationTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('关联关系导入模板', res)
          }
          break
        // 下载关联对象导入模板
        case 'relationObj':
          res = await associatedObjectsService.downloadTemplate()
          if (res) {
            fnMixin.methods.downLoadExcel('关联对象导入模板', res)
          }
          break
        // 下载测点导入模板
        case 'point':
          res = await this.apiPoint({ method: 'template' })
          if (res) {
            fnMixin.methods.downLoadExcel('测点导入模板', res)
          }
          break
        default:
          // 类别管理模板
          if (this.customization) {
            res = await CommonService.downloadTemplateCommon({
              reqUrl: this.hash
                ? `${this.excelType}/download_import_template${this.hash}&filter_attribute_group=1`
                : `${this.excelType}/download_import_template?filter_attribute_group=1`, // filter_attribute_group=1 下载标准模板过滤属性分组
              downloadType: 0,
            })
            if (res) {
              if (this.excelType === 'std/StdStandard') {
                fnMixin.methods.downLoadExcel('标准导入模板', res)
              }
              if (this.excelType === 'std/StdAttribute') {
                fnMixin.methods.downLoadExcel('标准属性模板', res)
              }
              if (this.excelType === 'std/StdClass') {
                fnMixin.methods.downLoadExcel('类别导入模板', res)
              }
              if (this.excelType === 'std/StdClassData') {
                fnMixin.methods.downLoadExcel(`${this.stdClassName}-数据明细导入`, res)
              }
            }
          } else {
            res = await CommonService.downloadTemplate({
              urlParam: `route_name=${this.excelType}`,
              downloadType: 0,
            })
            if (res && res.url) {
              if (_.includes(res.url, '://')) {
                window.location.href = res.url
              } else {
                window.location.href = `${currentEnv.VUE_APP_STANDARD_SERVER}${res.url}`
              }
            }
          }
      }
      if (API !== '' && ADDRESS !== '') window.location.href = `${API}${ADDRESS}`
    },
    // 下一步
    nextStep() {
      if (!this.attrRulesVal && this.isVariable) {
        this.$message.warning('属性规则不能为空！')
        return
      }
      this.active += 1
      if (this.active > 2) {
        this.active = 1
      }
    },
    // 获取上传的内容
    getFileContent(file) {
      console.log(file, 'rree')
      this.file = file
    },
    // 上传
    async uploadExcel() {
      this.loading = true
      let res = null
      const formData = new FormData()
      _.forIn({ file: this.file }, (value, key) => {
        formData.append(key, value)
      })
      if (!_.isEmpty(this.excelParams)) {
        _.forIn(this.excelParams, (value, key) => {
          formData.append(key, value)
        })
      }
      switch (this.excelType) {
        // 导入元数据采集
        case 'collection':
          this.resultFileName = '元数据采集导入返回结果'
          res = await MetadataManageService.import(formData)
          break
        // 导入数据规则设置
        case 'dataRuleSet':
          this.resultFileName = '数据规则设置导入返回结果'
          formData.append('standardId', this.standardId)
          res = await DataRuleSettingService.import(formData)
          break
        // 导入数据字典
        case 'DicCate':
          this.resultFileName = '数据字典导入返回结果'
          res = await CommonStdService.importDataDictionary(formData)
          break
        // 基础规则批量导入
        case 'baseRule':
          this.resultFileName = '基础规则导入返回结果'
          res = await EncodeRuleManage.uploadBaseRule(formData)
          break
        // 编码规则批量导入
        case 'encodeRule':
          this.resultFileName = '编码规则导入返回结果'
          res = await EncodeRuleManage.uploadEncodeRule(formData)
          break
        // 属性规则批量导入
        case 'attributeRule':
          this.resultFileName = '属性规则导入返回结果'
          res = await EncodeRuleManage.uploadAttributeRule(formData)
          break
        // 实体对象批量导入
        case 'objTransfer':
          this.resultFileName = '实体对象导入返回结果'
          res = await DocumentManagementService.importObjTrans(
            { standardId: this.standardId },
            formData
          )
          break
        // 属性规则文件导入
        case 'attrRulesFile':
          formData.append('codeRuleId', this.attrRulesVal)
          res = await EncodeRuleManage.uploadAttrRuleFiles({
            siteId: this.currentProject.id,
            formData,
          })
          break
        // 实体文档批量导入
        case 'documentList':
          this.resultFileName = '实体文档导入返回结果'
          formData.append('standardId', this.params.standardId)
          res = await DocumentManagementService.getDocumentImport(formData)
          break
        // 关联关系批量导入
        case 'relation':
          this.resultFileName = '关联关系导入返回结果'
          res = await DocumentManagementService.relationObjImport(formData)
          break
        // 关联对象批量导入
        case 'relationObj':
          this.resultFileName = '关联对象导入返回结果'
          res = await associatedObjectsService.import(formData)
          break
        // 测点模板导入
        case 'point':
          this.resultFileName = '测点导入返回结果'
          res = await this.apiPoint({
            method: 'upload',
            // params: { siteId: this.currentProject.id },
            formData,
          })
          break
        default:
          res = await CommonService.uploadFile({
            reqUrl: `${this.excelType}/import${this.hash}`,
            reqData: formData,
          })
          if (this.excelType === 'std/StdStandard') {
            this.resultFileName = '标准导入返回结果'
          }
          if (this.excelType === 'std/StdAttribute') {
            this.resultFileName = '标准属性导入返回结果'
          }
          if (this.excelType === 'std/StdClass') {
            this.resultFileName = '类别导入返回结果'
          }
          if (this.excelType === 'std/StdClassData') {
            this.resultFileName = `${this.stdClassName}-数据明细导入`
          }
      }
      this.loading = false
      if (
        _.includes(
          [
            'DicCate',
            'point',
            'attributeRule',
            'baseRule',
            'encodeRule',
            'relation',
            'objTransfer',
            'std/StdStandard',
            'std/StdAttribute',
            'std/StdClass',
            'std/StdClassData',
            'relationObj',
            'documentList',
            'dataRuleSet',
            'collection',
          ],
          this.excelType
        )
      ) {
        // 导入数据字典，导入测点模板，导入属性规则, 导入基础规则,关联关系,实体对象,标准库管理，标准属性管理，实体管理，实体数据管理,关联对象,实体文档,数据规则设置,元数据采集
        if (res && !res.msg) {
          this.active = 3
          this.resultFile = res
          this.$message.success(this.$t('viewDownloadResult'))
        } else if (res.msg) {
          this.$message.error(res.msg)
        }
      } else if (res && res.url) {
        this.active = 3
        this.resultFile = res.url
        if (res.code === 0) {
          this.$message.success(this.$t('viewDownloadResult'))
        }
      }
    },
    downResultFile() {
      // 下载结果文件
      console.log(this.resultFile, 'resultFile')
      if (
        _.includes(
          [
            'DicCate',
            'point',
            'attributeRule',
            'baseRule',
            'encodeRule',
            'relation',
            'objTransfer',
            'std/StdStandard',
            'std/StdAttribute',
            'std/StdClass',
            'std/StdClassData',
            'relationObj',
            'documentList',
            'dataRuleSet',
            'collection',
          ],
          this.excelType
        )
      ) {
        // 数据字典，测点，属性规则, 基础规则,关联关系,关联对象,实体文档,数据规则设置,元数据采集
        fnMixin.methods.downLoadExcel(this.resultFileName, this.resultFile)
        return
      }
      if (this.resultFile.startsWith('/')) {
        console.log(_.includes(this.resultFile, '://'))
        if (_.includes(this.resultFile, '://')) {
          window.location.href = this.resultFile
        } else {
          window.location.href = `${currentEnv.VUE_APP_STANDARD_SERVER}${this.resultFile}`
        }
      } else {
        console.log(_.includes(this.resultFile, '://'))
        if (_.includes(this.resultFile, '://')) {
          window.location.href = this.resultFile
        } else {
          window.location.href = `${currentEnv.VUE_APP_STANDARD_SERVER}${this.resultFile}`
        }
      }
    },
    closeDialog() {
      this.$emit('refreshList')
      this.active = 1
      this.file = ''
      this.resultFile = ''
      this.uploadExcelVisible = false
    },
  },
}
</script>

<style scoped lang="scss">

.iconfont {
  &.icon-d-excel {
    font-size: 70px !important;
  }
  &.icon-download {
    font-size: 54px !important;
  }
}
/deep/.el-upload-dragger {
  margin-top: 25px;
}
/deep/.el-step.is-simple /deep/.el-step__title {
  font-size: 15px !important;
}
.main-color {
  color: var(--systemMainColor);
}

</style>
